
                  export default function (Component) {
                      Component.__source = "library/components/VabRefresh/index.vue"
                  }
              